export const oraciónenelhuerto = {
	nombre: "Oración en el Huerto",
	dia: "Jueves Santo",
	nombrecompleto:
		"Venerable Cofradía de Penitencia de Nuestro Padre Jesús de la Oración en el Huerto y Nuestra Señora de Gracia y Esperanza",
	sede: "Parroquia de San Severiano",
	pasos: 2,
	distancia: [1890, 2620],
	penitentes: 200,
	cargadores: 126,
	web: "http://www.diariodecadiz.es/semana_santa/Huerto_0_1229577727.html",

	ida: [
		{ lng: -6.284289, lat: 36.522631 },
		{ lng: -6.284169, lat: 36.5227717 },
		{ lng: -6.2846786, lat: 36.5230788 },
		{ lng: -6.2848905, lat: 36.5230077 },
		{ lng: -6.2850621, lat: 36.5232836 },
		{ lng: -6.2858373, lat: 36.5237255 },
		{ lng: -6.2866527, lat: 36.5253054 },
		{ lng: -6.2875593, lat: 36.5260986 },
		{ lng: -6.2879187, lat: 36.5259305 },
		{ lng: -6.2881815, lat: 36.5260037 },
		{ lng: -6.2883827, lat: 36.5262452 },
		{ lng: -6.2887421, lat: 36.5265275 },
		{ lng: -6.2889111, lat: 36.5266999 },
		{ lng: -6.2889487, lat: 36.5270103 },
		{ lng: -6.288777, lat: 36.5274457 },
		{ lng: -6.2888736, lat: 36.5277733 },
		{ lng: -6.2891203, lat: 36.5281225 },
		{ lng: -6.2897801, lat: 36.5282216 },
		{ lng: -6.2902308, lat: 36.5286484 },
		{ lng: -6.290448, lat: 36.5287755 },
		{ lng: -6.2902629, lat: 36.5291376 },
		{ lng: -6.2913036, lat: 36.5296614 },
		{ lng: -6.2921968, lat: 36.5302648 },
		{ lng: -6.2919688, lat: 36.5304701 },
		{ lng: -6.2923953, lat: 36.5309707 },
		{ lng: -6.2926514, lat: 36.531253 },
		{ lng: -6.2929244, lat: 36.5310811 },
		{ lng: -6.2925505, lat: 36.5306886 },
		{ lng: -6.2922147, lat: 36.5303027 },
		{ lng: -6.2927878, lat: 36.5298273 },
		{ lng: -6.2932751, lat: 36.5297346 },
		{ lng: -6.2937585, lat: 36.529692 },
		{ lng: -6.2945293, lat: 36.529632 },
		{ lng: -6.294619, lat: 36.5295604 },
		{ lng: -6.2950487, lat: 36.5296168 },
		{ lng: -6.29528, lat: 36.5290148 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957051, lat: 36.5290816 },
		{ lng: -6.2954262, lat: 36.5297605 },
		{ lng: -6.2956689, lat: 36.5299523 },
		{ lng: -6.2952693, lat: 36.5303694 },
		{ lng: -6.2950212, lat: 36.5308403 },
		{ lng: -6.2949219, lat: 36.5308349 },
		{ lng: -6.2949219, lat: 36.5314524 },
		{ lng: -6.2964521, lat: 36.5317821 },
		{ lng: -6.2963985, lat: 36.5318489 },
		{ lng: -6.2965782, lat: 36.5321345 },
		{ lng: -6.2967928, lat: 36.5325408 },
		{ lng: -6.2964293, lat: 36.5329276 },
		{ lng: -6.2962604, lat: 36.5332417 },
		{ lng: -6.2963241, lat: 36.5332859 },
		{ lng: -6.296253, lat: 36.5339384 },
		{ lng: -6.2960062, lat: 36.5339713 },
		{ lng: -6.2954624, lat: 36.5340192 },
		{ lng: -6.2932348, lat: 36.5314545 },
		{ lng: -6.2929103, lat: 36.5316442 },
		{ lng: -6.2919205, lat: 36.530461 },
		{ lng: -6.2921458, lat: 36.5302778 },
		{ lng: -6.2912822, lat: 36.5296915 },
		{ lng: -6.2902066, lat: 36.5291419 },
		{ lng: -6.2895012, lat: 36.5287346 },
		{ lng: -6.2888387, lat: 36.5277841 },
		{ lng: -6.288726, lat: 36.5274349 },
		{ lng: -6.2889084, lat: 36.5270211 },
		{ lng: -6.2888736, lat: 36.5267129 },
		{ lng: -6.2883532, lat: 36.526271 },
		{ lng: -6.2881467, lat: 36.5260296 },
		{ lng: -6.287916, lat: 36.525965 },
		{ lng: -6.2875324, lat: 36.5261438 },
		{ lng: -6.2866044, lat: 36.5253226 },
		{ lng: -6.2857944, lat: 36.5237513 },
		{ lng: -6.2850058, lat: 36.5233019 },
		{ lng: -6.2848744, lat: 36.5230567 },
		{ lng: -6.2846692, lat: 36.5231162 },
		{ lng: -6.284112, lat: 36.5227764 },
		{ lng: -6.2842441, lat: 36.5226175 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-29T17:00",
			latlng: [36.52263, -6.28428]
		},
		{
			name: "Nueva",
			hora: "2018-03-29T20:25",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-29T21:25",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-29T22:25",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-29T22:50",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-29T23:00",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Tolosa Latour (izq.)",
			"Plaza de San Severiano",
			"Acacias",
			"Avda. Bahia Blanca",
			"Plaza de la Constitución",
			"Cuestas de las Calesas",
			"La Perla de Cádiz",
			"Santo Domingo",
			"Compás de Santo Domingo",
			"Plocia",
			"Plaza de San Juan de Dios",
			"Avda. 4 de Diciembre de 1977",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cádiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Sanchez Barcaiztegui",
			"Avda. 4 de Diciembre de 1977",
			"Plaza de San Juan de Dios",
			"Plocia",
			"Cuesta de las Calesas",
			"Plaza de la Constitución",
			"Avda. Bahia Blanca",
			"Acacias",
			"Plaza de San Severiano",
			"Tolosa Latour"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/oraciónenelhuerto.js